import { Box, Button, Card, CardContent, Divider, Stack, TextField, Typography } from '@mui/material'
import React, { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useForm, Controller } from 'react-hook-form';
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import axiosInstance from '../../../api/axiosInstance';
import { removeData } from '../../../Redux/Feature/AdminSlice';

function AddCarousel() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    register,
    watch,
  } = useForm({
    mode: "onTouched",
  });

    const Imgwatch = watch("img");

    const imgFile = useRef();

    const handleSave = async () => {
        if(Imgwatch){
            try {
                const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}add-carousel`, {
                    image : Imgwatch
                }, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                console.log(response)
                if(response.status === 201){
                    console.log(response)
                    toast.success("Carousel Added Successfully!")
                    navigate('/Admin/carousel')
                }
             } catch (error) {
                 console.log(error)
                 toast.error('Something went wrong!')
                 if(error.response.status === 401 || error.response.status === 403){
                  navigate('/Admin/login')
                  dispatch(removeData())
              }
             }
        } else {
            toast.error("Please select an image!")
        }
    }

  return (
    <div>
        <ToastContainer />
        <Button onClick={() => navigate('/Admin/carousel')} sx={{color : 'black'}}><ArrowBackIcon /></Button>

        <Box sx={{display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
            
            
            <Card sx={{ width: '80%', border:'1px solid #E5E7EB', borderRadius:"6px"}}>
        <CardContent style={{ padding: 0, margin: 0 }}>
        <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Add Carousel Image</Typography>
            </Box>
            <Box sx={{mt : 2}}>
            {Boolean(Imgwatch) ? (
                  <Box style={{ padding: "0px 17px 17px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  padding="23px"
                  borderRadius="8px"
                  sx={{ border: ".5px solid #1A2461" }}
                >
                  <Typography
                    variant="h9_1"
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <ImgIcon />
                    {Imgwatch?.name}
                  </Typography>
                  <ClearIcon
                    onClick={() => setValue("img", null)}
                    sx={{ color: "#1A2461" }}
                  />
                </Stack>
                </Box>
              ) : (
                <Box
                  xs={12}
                  onClick={() => imgFile.current.click()}
                  sx={{
                    border: Boolean(errors.img)
                      ? "1px dashed red"
                      : "1px dashed #1A2461",
                    height: "200px",
                    borderRadius: "8px",
                    backgroundColor: "#F9FBFF",
                    margin: '20px 17px 17px'
                  }}
                >
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        height: "100px",
                        width: "100px",
                        borderRadius: "100px",
                        backgroundColor: "#F2F2F2",
                      }}
                    >
                      <UploadFileIcon fill="#1A2461" />
                    </Stack>
                    <Stack mt={2} direction="row" alignItems="center" gap="5px">
                      <Typography variant="h9_1">Click to upload</Typography>
                    </Stack>
                    <Typography variant="h9_5">
                      Allowed formats - JPEG, PNG
                    </Typography>
                  </Stack>
                  <Box sx={{marginTop : '0.3rem'}}>
                      {errors?.img ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select an Image</Typography> : null}
                    </Box>
                </Box>
              )}
              <Controller
                name="img"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      field.onChange(e.target.files[0]);
                      e.target.value = null;
                    }}
                    ref={(e) => {
                      imgFile.current = e;
                    }}
                    hidden
                  />
                )}
              />
              </Box>
              <Divider style={{marginTop : 2 }}/>
              <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button 
               variant="contained"
               onClick={() => handleSave()}
               sx={{
                 padding: "10px 20px 10px 20px",
                 mt: 2,
                 width: "20%",
                 fontSize: 20,
                 backgroundColor: "rgb(14, 94, 132)",
                 ":hover": { bgcolor: "rgb(14, 94, 132)" },
               }}>
                Confirm
              </Button>
              </Box>
        </CardContent>
        </Card>
        </Box>
    </div>
  )
}

export default AddCarousel